// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"683":"96491932","855":"7db265d6","2550":"7db265d6","2842":"dc12629a","3376":"7db265d6","5297":"7db265d6","7695":"7db265d6","7883":"7db265d6"}[chunkId] + ".chunk.css";
};